<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="80%" max-height="90%">
    <v-card>
      <v-card-title>
        <v-icon left>{{ getFileIcon() }}</v-icon>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text class="pa-0">
        <!-- Image Preview -->
        <div v-if="type === 'image'" class="text-center">
          <v-img 
            :src="url" 
            max-height="600" 
            contain
            :alt="title"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>
        
        <!-- PDF Preview -->
        <div v-else-if="type === 'pdf'" style="height: 70vh;">
          <embed 
            :src="url" 
            width="100%" 
            height="100%" 
            type="application/pdf" 
          />
        </div>
        
        <!-- Other File Types -->
        <div v-else class="text-center pa-8">
          <v-icon size="64" color="grey">{{ getFileIcon() }}</v-icon>
          <div class="text-h6 mt-2">ไม่สามารถแสดงตัวอย่างไฟล์นี้ได้</div>
          <div class="text-caption grey--text mt-1">{{ getFileExtension() }} file</div>
          <v-btn 
            color="primary" 
            :href="url" 
            target="_blank" 
            class="mt-3"
            download
          >
            <v-icon left>mdi-download</v-icon>
            ดาวน์โหลด
          </v-btn>
        </div>
      </v-card-text>
      
      <!-- Action buttons for all file types -->
      <v-card-actions v-if="type === 'image' || type === 'pdf'">
        <v-spacer></v-spacer>
        <v-btn 
          text 
          color="primary"
          :href="url" 
          target="_blank"
          download
        >
          <v-icon left>mdi-download</v-icon>
          ดาวน์โหลด
        </v-btn>
        <v-btn 
          text 
          color="primary"
          :href="url" 
          target="_blank"
        >
          <v-icon left>mdi-open-in-new</v-icon>
          เปิดในแท็บใหม่
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'FilePreviewDialog',
  
  props: {
    value: Boolean,
    url: String,
    title: String,
    type: String
  },
  
  methods: {
    getFileIcon() {
      switch (this.type) {
        case 'image':
          return 'mdi-image'
        case 'pdf':
          return 'mdi-file-pdf-box'
        default:
          return 'mdi-file-document'
      }
    },
    
    getFileExtension() {
      if (!this.url) return ''
      const parts = this.url.split('.')
      return parts.length > 1 ? parts.pop().toUpperCase() : 'FILE'
    }
  }
}
</script>

<style scoped>
/* Ensure proper PDF display */
embed {
  border: none;
  border-radius: 4px;
}

/* Image loading state */
.v-image__image--preload-done {
  filter: none;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .v-dialog {
    margin: 12px;
  }
}
</style>